import { Route } from '@angular/router';
import { SingleProductResolver } from './page/library-management/single-product.resolver';
import { Auth0Guard } from './shared/guard/auth0.guard';
import { CanLoginGuard } from './shared/guard/can-login.guard';

export const appRoutes: Route[] = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./page/auth/auth.routes').then(m => m.authRoutes),
    canActivate: [CanLoginGuard],
  },
  {
    path: '',
    loadComponent: () =>
      import('./core/layout/main-layout/main-layout.component').then(
        m => m.MainLayoutComponent
      ),
    canActivate: [Auth0Guard],
    children: [
      {
        path: '',
        redirectTo: 'accounts',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./page/dashboard/routes').then(m => m.routes),
      },
      {
        path: 'accounts',
        loadChildren: () =>
          import('./page/accounts/routes').then(m => m.routes),
      },
      {
        path: 'remote-client-search',
        loadChildren: () =>
          import('./page/remote-client-search/routes').then(m => m.routes),
      },
      {
        path: 'system',
        loadChildren: () => import('./page/system/routes').then(m => m.routes),
      },
      {
        path: 'library-management',
        loadChildren: () =>
          import('./page/library-management/routes').then(m => m.routes),
      },
      {
        path: 'library-management/distributors/:id/products/:productId',
        loadComponent: () =>
          import(
            './page/library-management/products/product-detail/product-detail.component'
          ).then(l => l.ProductDetailComponent),
        resolve: {
          product: SingleProductResolver,
        },
      },
      {
        path: 'library-management/distributors/:id/products/product/add',
        loadComponent: () =>
          import(
            './page/library-management/distributors/products-tab/product-add/product-add.component'
          ).then(l => l.ProductAddComponent),
      },
      {
        path: 'library-management/distributors/:id/products/:productId/edit',
        loadComponent: () =>
          import(
            './page/library-management/distributors/products-tab/product-edit/product-edit.component'
          ).then(l => l.ProductEditComponent),
        resolve: {
          product: SingleProductResolver,
        },
      },
      {
        path: 'users',
        loadChildren: () => import('./page/user/routes').then(m => m.routes),
      },
      {
        path: 'message',
        loadChildren: () => import('./page/message/routes').then(m => m.routes),
      },
    ],
  },
];
